import React from 'react';
import ReactDOM from "react-dom";
import Axios from 'axios';
import '../mainCSS/filter.css';
import PriceRange from './price-range';
import BrandsSelect from './brands-select';
import SizesSelect from './sizes-select';
import FeaturesSelect from './features-select';
import ShopProfile from './shopProfile';
import Products from './products';
import Loader from './loader';

export default class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lenght: null,
            minLenght: null,
            allow: false
        };
    }

    componentDidMount() {
        var url_string = window.location.href;
        //var url_string = 'https://www.erotikastore.eu/szexshop/54/1/noi-ruha-fehernemu-body';
        //var url_string = 'https://www.erotikastore.eu/segedeszkoz/7/noi-ruha-fehernemu';
        //itt le kellene kérdezni, hogy lehetségese a szűrő
        var url = ShopProfile.getURL() + '/index/reactFetch.php';
        var data = new URLSearchParams({
            event: 'filter-data',
            url: url_string,
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                ShopProfile.setUrlPath(window.location.href)
                ShopProfile.setPriceMin(0);
                ShopProfile.setPriceMax(parseInt(res.data['maxPrice']));
                ShopProfile.setRangeLenght(parseInt(res.data['maxPrice'])); //A legdrábább termék adja meg a max csúszka hosszát!
                ShopProfile.setRangeMinlenght(parseInt(res.data['maxPrice'] / 2)); //A min csúszkát a felére veszem alapból
                ShopProfile.setCategoryID(parseInt(res.data['categoryID']));
                ShopProfile.setGroupID(res.data['groupID']);
                ShopProfile.setNavValue(0);
                ShopProfile.setNavStep(res.data['navStep']);
                this.setState({
                    allow: res.data['allow'],
                    lenght: parseInt(res.data['maxPrice']),
                    minLenght: parseInt(res.data['maxPrice'] / 2)
                })
                if (res.data['allow'] === true) {
                    this.filterToolsShow();
                }
            })
    }

    filterReset() {
        document.getElementById('filter-reset').style.display = 'none';
        ShopProfile.resetFilter();
        this.productsShow();
        const nextURL = ShopProfile.getUrlPath();
        const nextTitle = 'Szűrő';
        const nextState = { additionalInformation: 'Szűrő feltételek törölve' };
        window.history.replaceState(nextState, nextTitle, nextURL);
    }

    filterToolsShow(show) {
        setTimeout(function () {
            ReactDOM.render(
                <ul>
                    <li>
                        <span></span>
                        <span></span>
                        <span></span>
                        <i className='fa filter'></i>
                        <p>
                            {'Szűrés'}
                        </p>
                    </li>
                </ul>,
                document.getElementById('filter-tools')
            );
        }, 10);
    }

    delElement(name) {
        var div = document.getElementById(name);
        div.remove();
    }

    addElement(name, text, call) {
        var div = document.createElement('div');
        div.id = name;
        if (text !== '') {
            div.innerHTML = text;
        }
        if (call !== '') {
            div.addEventListener("click", function () {
                new Filter().filterHide();
            });
        }
        document.body.appendChild(div);
    }

    priceRange() {
        return (
            <div>
                <PriceRange />
            </div>
        );
    }

    companySelect() {
        return (
            <div>
                <BrandsSelect />
            </div>
        );
    }

    sizesSelect() {
        return (
            <div>
                <SizesSelect />
            </div>
        );
    }

    featuresSelect() {
        return (
            <div>
                <FeaturesSelect />
            </div>
        );
    }

    narrowing() {
        return (
            <div id='narrow'>
                <div id='narrowing' onClick={() => this.products()}>
                    {'OK'}
                </div>
            </div>
        )
    }

    productsShow() {
        //window.scrollTo(0, 0);
        setTimeout(function () {
            ReactDOM.render(
                <Loader />,
                document.getElementById("content")
            );
        }, 100);
        setTimeout(function () {
            ReactDOM.render(
                <Products />,
                document.getElementById("content")
            );
        }, 150);
    }

    filterUrlTag(brands, sizes, features) {
        var i = 0;
        var tag = '';
        var brandTag = '';
        var sizesTag = '';
        var featuresTag = '';
        if (brands.length > 0) {
            for (i = 0; i < brands.length; i++) {
                brandTag = brandTag === '' ? 'brands=' + brands[i] : brandTag + '_' + brands[i];
            }
            tag = tag === '' ? brandTag : tag + '&' + brandTag;
        }
        if (sizes.length > 0) {
            for (i = 0; i < sizes.length; i++) {
                sizesTag = sizesTag === '' ? 'sizes=' + sizes[i] : sizesTag + '_' + sizes[i];
            }
            tag = tag === '' ? sizesTag : tag + '&' + sizesTag;
        }
        if (features.length > 0) {
            for (i = 0; i < features.length; i++) {
                featuresTag = featuresTag === '' ? 'features=' + features[i] : featuresTag + '_' + features[i];
            }
            tag = tag === '' ? featuresTag : tag + '&' + featuresTag;
        }
        return tag;
    }

    products() {
        //Új keressnél alapra rakom a navigációt.
        ShopProfile.setNavValue(0);
        ShopProfile.setNavFrom(0);
        this.filterHide();
        this.productsShow();
        //bekapcsolom a szűrő törlését
        var priceMin = ShopProfile.getPriceMin();
        var priceMax = ShopProfile.getPriceMax();
        var rangeLenght = ShopProfile.getRangeLenght();
        var brands = ShopProfile.getBrands();
        var sizes = ShopProfile.getSizes();
        var features = ShopProfile.getFeatures();
        const nextURL = '?' + this.filterUrlTag(brands, sizes, features);
        const nextTitle = 'Szűrő';
        const nextState = { additionalInformation: 'Szűrő beállítva' };
        window.history.pushState(nextState, nextTitle, nextURL);
        if (priceMin !== 0 || priceMax !== rangeLenght || brands.length > 0 || sizes.length > 0 || features.length > 0) {
            document.getElementById('filter-reset').style.display = 'block';
        }
    }

    filterShow() {
        this.addElement('overlay', '', 'click');
        this.addElement('popUpAppShow', '', '');
        this.addElement('popUpClose', '<b><i>X</i></b>', 'click');
        ReactDOM.render(
            <Loader />,
            document.getElementById("popUpAppShow")
        );
        var priceRange = this.priceRange();
        var companySelect = this.companySelect();
        var sizesSelect = this.sizesSelect();
        var features = this.featuresSelect();
        var but = this.narrowing();
        setTimeout(function () {
            ReactDOM.render(
                <div>
                    {priceRange}
                    {companySelect}
                    {sizesSelect}
                    {features}
                    {but}
                </div>,
                document.getElementById('popUpAppShow')
            );
        }, 100);
    }

    filterHide() {
        var overlay = document.getElementById('overlay');
        overlay.remove();
        var popUpAppShow = document.getElementById('popUpAppShow');
        popUpAppShow.remove();
        var popUpClose = document.getElementById('popUpClose');
        popUpClose.remove();
    }

    render() {
        return (
            <div>
                <div id='filter-tools' onClick={() => this.filterShow()}>
                </div>
                <button id='filter-reset' onClick={() => this.filterReset()}>
                    <i className='fa rotate'></i>
                    {'Mindent visszaállít'}
                </button>
            </div>
        );
    }
}